export const preferencesModule =
  typeof window !== "undefined"
    ? require("service-worker-i18n-redirect/preferences")
    : null
